import React, {Component,Fragment} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap-modal'

class ConfirmModal extends Component {
    constructor(props){
        super(props)

        this.state = {
            modalIsOpen:false,
            params: props
        }
    }
    handleClick(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            modalIsOpen:true
        })
    }
    handleClose(){

        this.setState({
            modalIsOpen:false
        })
    }
    handleCancel(){
        this.handleClose()
        if(this.props.onCancel !== undefined){
            this.props.onCancel()
        }
    }
    handleConfirm(){
        this.handleClose()
        if(this.props.onConfirm !== undefined){
            this.props.onConfirm()
        }
    }
    render() {
        const childrenWithExtraProp = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick:(e)=>this.handleClick(e)
            });
        });
        return (
            <Fragment>
                {childrenWithExtraProp}
                <Modal
                    show={this.state.modalIsOpen}
                    onHide={()=>this.handleClose()}
                    aria-labelledby="ModalHeader"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id='ModalHeader'>{this.props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{this.props.description}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.Dismiss className='btn btn-primary'>{this.props.cancelText}</Modal.Dismiss>
                        <button className='btn btn-danger' onClick={()=>{this.handleConfirm()}}>
                            {this.props.okText}
                        </button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

ConfirmModal.propTypes = {
    okText:PropTypes.string,
    cancelText:PropTypes.string,
    title:PropTypes.string,
    description:PropTypes.string,
    onConfirm:PropTypes.func
};
ConfirmModal.defaultProps = {
    okText:"Да",
    cancelText:"Нет",
    title:"Подтверждаете действие?",
    description:null
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/components/Shared/ConfirmModal/index.jsx